class CollapseContainer {

  /**
  * @constructor
  * @param {HTMLElement} element element to bind to
  */
  constructor( element ) {
    this._element = element;

    this._collapseArea = document.querySelector( this._element.dataset.target );
    this._handleTextElement = element.querySelector('span.text') ?? element;

    this._handleText = {
      primary: this._element.innerText,
      alternative: this._element.dataset.altText,
    };

    if (this._collapseArea) {
      this._element.addEventListener('click', this._onCollapseHandleClicked.bind(this) );
    }
  }

  /**
   * Collapse handle click event
   * @param {MouseEvent} event - Event
   */
  _onCollapseHandleClicked(event) {

    event.preventDefault();
    this._collapseArea.classList.toggle('collapse-area__container--open');
    this._element.classList.toggle('collapse-area__handle--open');

    const isOpen = this._element.classList.contains('collapse-area__handle--open')

    if(isOpen) {
      this._collapseArea.style.maxHeight = this._collapseArea.scrollHeight + 'px';
    } else {
      this._collapseArea.style.maxHeight = null;
    }

    if (this._handleText.alternative) {
      this._handleTextElement.innerText = this._handleTextElement.innerText === this._handleText.primary ? this._handleText.alternative : this._handleText.primary;
    }

    if( this._element.classList.contains('f-icon') ) {
      this._element.classList.toggle( this._element.dataset.openIcon, !isOpen );
      this._element.classList.toggle( this._element.dataset.closedIcon, isOpen );
    }
  }

  /**
   * Called to initialize collapse areas and handles
   */
  static init() {
    document.querySelectorAll('.collapse-area__handle').forEach( element => new CollapseContainer( element ) );
  }
}

export default CollapseContainer;
